/**
 * Formats currency input to allow only 2 decimal places
 * @param {string} value - The input value
 * @returns {string} - Formatted value with max 2 decimal places
 */
export const formatCurrencyInput = (value) => {
  // Remove any non-numeric characters except decimal point
  let cleaned = value.replace(/[^\d.]/g, '');
  
  // Ensure only one decimal point
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    cleaned = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // Limit to 2 decimal places
  if (parts.length === 2) {
    cleaned = parts[0] + '.' + parts[1].slice(0, 2);
  }
  
  return cleaned;
};

/**
 * Validates and parses currency input
 * @param {string} value - The input value
 * @returns {number} - Parsed float value
 */
export const parseCurrencyInput = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : Math.round(parsed * 100) / 100;
};

